'use strict';

import 'angular';

import './style.css';

import groupDirective from './group';
import slideDirective from './slide';
import selectDirective from './select';
import backDirective from './back';
import animation from './animation';

const MODULE_NAME = 'brg.components.slides';

var app = angular.module(MODULE_NAME, []);
app.directive('brgSlideGroup', groupDirective);
app.directive('brgSlide', slideDirective);
app.directive('brgSlideSelect', selectDirective);
app.directive('brgSlideBack', backDirective);
app.animation('.brg-slide', animation);

export default MODULE_NAME;
